export default __webpack_public_path__ + "static/media/ATRPortes.52395779.png";